export default "__VITE_ASSET__BQNiRRZW__"